import Link from 'next/link'

const NewsCard = (props) => {
  const { title, color, uri, header, published } = props

  let modifier = (color && color !== 'default') ? ` NewsCard--${color}` : ''
  console.log("Uri", uri);
  return (
    <Link as={`/${uri}`} href={`/news/[slug]`}>
      <a className={`NewsCard${modifier}`}>
        {header[0].image.length ?
          <div className="NewsCard-aside">
            <div className="NewsCard-figure">
              <img className="NewsCard-image" src={header[0].image[0].url} alt={header[0].image[0].title}/>
              <img className="NewsCard-image is-normal" src={header[0].image[0].url} alt={header[0].image[0].title}/>
            </div>
          </div>
          : ``
        }
        {title &&
        <div className="NewsCard-main">
          <div className="NewsCard-content">
            <div className="NewsCard-title">
              <p>{title}</p>
            </div>
            {published &&
            <div className="NewsCard-label">
              <span className="NewsCard-labelText">{published}</span>
            </div>
            }
          </div>
        </div>
        }
      </a>
    </Link>
  )
}

export default NewsCard
